module.exports = __webpack_public_path__ + "img/sukarya_yes.6a1290a9.png";